import styled, { css } from 'styled-components';
import { FlexCenteredColumn } from '../../../../../styled/common';
import { Typography } from '../../../../ui/Typography';

export const UploadPhotoWrapper = styled(FlexCenteredColumn)<{
  hasImages: boolean;
}>`
  justify-content: center;
  width: 100%;
  height: 105px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 14px;
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='14' ry='14' stroke='%234264FDFF' stroke-width='2' stroke-dasharray='5' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    ${({ hasImages }) =>
      !hasImages &&
      css`
        height: 200px;
      `}
  }

  ${({ hasImages }) =>
    hasImages &&
    css`
      height: 105px;
      border: 1px solid ${({ theme }) => theme.colors.border.secondary};
      background-image: none;

      @media (min-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
        height: 120px;
      }
    `}
`;

export const PhotoText = styled(Typography)`
  color: ${({ theme }) => theme.colors.systemColors.blue};
  display: inline-block;
  margin-top: 8px;

  @media (min-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    margin-top: 15px;
  }
`;

export const PhotoInput = styled.input`
  display: none;
`;
